import { all } from "redux-saga/effects"

import formulaireSaga from "ContainersForm/DisplayForm/saga"
import activitySaga from "ContainersForm/Activity/saga"
import riskSaga from "ContainersForm/Risks/saga"
import planControlSaga from "ContainersForm/ControlPlans/saga"
import documentManagementSaga from "ContainersForm/DocumentManagement/saga"
import actionPlanSaga from "ContainersForm/ActionPlan/saga"
import recommendationsSaga from "ContainersForm/Recommendations/saga"
import nonConformitySaga from "ContainersForm/NonConformity/saga"
import mappingRiskSaga from "ContainersForm/MappingRisk/saga"
import customListsSaga from "ContainersForm/CustomLists/saga.js"
import auditPlansSaga from "ContainersForm/AuditPlans/saga.js"
import customSkeletonsSaga from "ContainersForm/CustomSkeletons/saga.js"
import ETLSaga from "ContainersForm/ETL/saga.js"

export default function* rootSaga() {
  yield all([
    formulaireSaga(),
    activitySaga(),
    riskSaga(),
    planControlSaga(),
    documentManagementSaga(),
    actionPlanSaga(),
    recommendationsSaga(),
    nonConformitySaga(),
    mappingRiskSaga(),
    customListsSaga(),
    auditPlansSaga(),
    customSkeletonsSaga(),
    ETLSaga(),
  ])
}
